/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AggregateByEnum } from '../models/AggregateByEnum'
import type { AveragedParkingCountsResponse } from '../models/AveragedParkingCountsResponse'
import type { OccupancyHoursEnum } from '../models/OccupancyHoursEnum'
import type { OccupancyMetricsEnum } from '../models/OccupancyMetricsEnum'
import type { OccupancyTopBottomByShapeResponse } from '../models/OccupancyTopBottomByShapeResponse'
import type { OccupancyWithCompareResponse } from '../models/OccupancyWithCompareResponse'
import type { Page_LayerResponse_ } from '../models/Page_LayerResponse_'
import type { Page_ParkingOperators_ } from '../models/Page_ParkingOperators_'
import type { Page_ParkingTransactionResponse_ } from '../models/Page_ParkingTransactionResponse_'
import type { ParkingCountResponse } from '../models/ParkingCountResponse'
import type { ParkingDateRangeResponse } from '../models/ParkingDateRangeResponse'
import type { ParkingDownloadUrlsResponse } from '../models/ParkingDownloadUrlsResponse'
import type { ParkingInsightsMetricsEnum } from '../models/ParkingInsightsMetricsEnum'
import type { ParkingOperatorDataType } from '../models/ParkingOperatorDataType'
import type { ParkingRevenueStatisticsResponse } from '../models/ParkingRevenueStatisticsResponse'
import type { ParkingSpatialResponse } from '../models/ParkingSpatialResponse'
import type { ParkingStatisticsResponse } from '../models/ParkingStatisticsResponse'
import type { PaymentTypeEnum } from '../models/PaymentTypeEnum'
import type { TimePeriodEnum } from '../models/TimePeriodEnum'
import type { CancelablePromise } from '../core/CancelablePromise'
import type { BaseHttpRequest } from '../core/BaseHttpRequest'
export class CurbParkingInsightsService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * Get Parking By Layer Statistics
   * Returns the summed total revenue, session count and average paid time
   * per session for all parking meter events in a given time period for
   * the provided layer, with all the revenue, paid time and session
   * counts assigned to the first hour in which the parking event occurs. Optional
   * operator and payment type filters on the data.
   * @returns ParkingRevenueStatisticsResponse Successful Response
   * @throws ApiError
   */
  public getParkingByLayerStatistics({
    regionId,
    shapeLayerUuid,
    startDate,
    endDate,
    startTime,
    endTime,
    daysOfWeek,
    operators,
    paymentTypes,
    shapeUuids,
    dataType,
    hours,
  }: {
    /**
     * Region identifier
     */
    regionId: string
    /**
     * Layer identifier
     */
    shapeLayerUuid: string
    /**
     * Filter for records that end after the provided ISO start date
     */
    startDate: string
    /**
     * Filter for records that start on or before the provided ISO end date
     */
    endDate: string
    /**
     * Filter for records that end after the provided ISO start time
     */
    startTime?: number | null
    /**
     * Filter for records that start on or before the provided ISO start time
     */
    endTime?: number | null
    /**
     * Filter for days of week
     */
    daysOfWeek?: Array<number> | null
    /**
     * Filter for records that are in this list of operators
     */
    operators?: Array<string> | null
    /**
     * Filter for records that are in this list of payment types
     */
    paymentTypes?: Array<PaymentTypeEnum> | null
    /**
     * Filter for one or more shapes or districts
     */
    shapeUuids?: Array<string> | null
    /**
     * Selector for payments or sensor based occupancy
     */
    dataType?: ParkingOperatorDataType | null
    /**
     * Enforced hours or all hours for occupancy supply
     */
    hours?: OccupancyHoursEnum | null
  }): CancelablePromise<ParkingRevenueStatisticsResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/regions/{region_id}/layers/{shape_layer_uuid}/curb_parking_insights/statistics',
      path: {
        region_id: regionId,
        shape_layer_uuid: shapeLayerUuid,
      },
      query: {
        start_date: startDate,
        end_date: endDate,
        start_time: startTime,
        end_time: endTime,
        days_of_week: daysOfWeek,
        operators: operators,
        payment_types: paymentTypes,
        shape_uuids: shapeUuids,
        data_type: dataType,
        hours: hours,
      },
      errors: {
        422: `Validation Error`,
      },
    })
  }
  /**
   * Get Parking By Layer Legend Values
   * Returns the full array of values for a given metric (eg. total sessions),
   * for all parking meter events in a given time period in the parking districts
   * shape_layer, with all the revenue, paid time and session counts assigned
   * to the first hour in which the parking event occurs. Optional operator and
   * payment type filters on the data.
   * @returns number Successful Response
   * @throws ApiError
   */
  public getParkingByLayerLegendValues({
    regionId,
    shapeLayerUuid,
    metric,
    startDate,
    endDate,
    startTime,
    endTime,
    daysOfWeek,
    operators,
    paymentTypes,
    shapeUuids,
    dataType,
    hours,
  }: {
    /**
     * Region identifier
     */
    regionId: string
    /**
     * Layer identifier
     */
    shapeLayerUuid: string
    /**
     * Return counts for revenue, sessions, average paid time, or average paid revenue.
     */
    metric: ParkingInsightsMetricsEnum
    /**
     * Filter for records that end after the provided ISO start date
     */
    startDate: string
    /**
     * Filter for records that start on or before the provided ISO end date
     */
    endDate: string
    /**
     * Filter for records that end after the provided ISO start time
     */
    startTime?: number | null
    /**
     * Filter for records that start on or before the provided ISO start time
     */
    endTime?: number | null
    /**
     * Filter for days of week
     */
    daysOfWeek?: Array<number> | null
    /**
     * Filter for records that are in this list of operators
     */
    operators?: Array<string> | null
    /**
     * Filter for records that are in this list of payment types
     */
    paymentTypes?: Array<PaymentTypeEnum> | null
    /**
     * Filter for one or more shapes or districts
     */
    shapeUuids?: Array<string> | null
    /**
     * Selector for payments or sensor based occupancy
     */
    dataType?: ParkingOperatorDataType | null
    /**
     * Enforced hours or all hours for occupancy supply
     */
    hours?: OccupancyHoursEnum | null
  }): CancelablePromise<Array<number>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/regions/{region_id}/layers/{shape_layer_uuid}/curb_parking_insights/legend_values',
      path: {
        region_id: regionId,
        shape_layer_uuid: shapeLayerUuid,
      },
      query: {
        metric: metric,
        start_date: startDate,
        end_date: endDate,
        start_time: startTime,
        end_time: endTime,
        days_of_week: daysOfWeek,
        operators: operators,
        payment_types: paymentTypes,
        shape_uuids: shapeUuids,
        data_type: dataType,
        hours: hours,
      },
      errors: {
        422: `Validation Error`,
      },
    })
  }
  /**
   * Get Curb Parking Insights Vector
   * Generates vector tiles for curb parking insights data, split by shape. Also
   * returns an int or float for the metric passed in as a filter.
   * @returns string Successful Response
   * @throws ApiError
   */
  public getCurbParkingInsightsVector({
    regionId,
    shapeLayerUuid,
    z,
    x,
    y,
    startDate,
    endDate,
    startTime,
    endTime,
    daysOfWeek,
    operators,
    paymentTypes,
    shapeUuids,
    dataType,
    hours,
    ifModifiedSince,
  }: {
    /**
     * Region identifier
     */
    regionId: string
    /**
     * Layer identifier
     */
    shapeLayerUuid: string
    z: number
    x: number
    y: number
    /**
     * Filter for records that end after the provided ISO start date
     */
    startDate: string
    /**
     * Filter for records that start on or before the provided ISO end date
     */
    endDate: string
    /**
     * Filter for records that end after the provided ISO start time
     */
    startTime?: number | null
    /**
     * Filter for records that start on or before the provided ISO start time
     */
    endTime?: number | null
    /**
     * Filter for days of week
     */
    daysOfWeek?: Array<number> | null
    /**
     * Filter for records that are in this list of operators
     */
    operators?: Array<string> | null
    /**
     * Filter for records that are in this list of payment types
     */
    paymentTypes?: Array<PaymentTypeEnum> | null
    /**
     * Filter for one or more shapes or districts
     */
    shapeUuids?: Array<string> | null
    /**
     * Selector for payments or sensor based occupancy
     */
    dataType?: ParkingOperatorDataType | null
    /**
     * Enforced hours or all hours for occupancy supply
     */
    hours?: OccupancyHoursEnum | null
    ifModifiedSince?: string | null
  }): CancelablePromise<string> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/regions/{region_id}/layers/{shape_layer_uuid}/curb_parking_insights/vector/{z}/{x}/{y}',
      path: {
        region_id: regionId,
        shape_layer_uuid: shapeLayerUuid,
        z: z,
        x: x,
        y: y,
      },
      query: {
        start_date: startDate,
        end_date: endDate,
        start_time: startTime,
        end_time: endTime,
        days_of_week: daysOfWeek,
        operators: operators,
        payment_types: paymentTypes,
        shape_uuids: shapeUuids,
        data_type: dataType,
        hours: hours,
        if_modified_since: ifModifiedSince,
      },
      errors: {
        422: `Validation Error`,
      },
    })
  }
  /**
   * Get Curb Parking Insights By Shape
   * Generates a count for a given curb parking metric, split by shape, for a given
   * layer and other filters.
   * @returns ParkingSpatialResponse Successful Response
   * @throws ApiError
   */
  public getCurbParkingInsightsByShape({
    regionId,
    shapeLayerUuid,
    metric,
    startDate,
    endDate,
    startTime,
    endTime,
    daysOfWeek,
    operators,
    paymentTypes,
    shapeUuids,
    dataType,
    hours,
  }: {
    /**
     * Region identifier
     */
    regionId: string
    /**
     * Layer identifier
     */
    shapeLayerUuid: string
    metric: ParkingInsightsMetricsEnum
    /**
     * Filter for records that end after the provided ISO start date
     */
    startDate: string
    /**
     * Filter for records that start on or before the provided ISO end date
     */
    endDate: string
    /**
     * Filter for records that end after the provided ISO start time
     */
    startTime?: number | null
    /**
     * Filter for records that start on or before the provided ISO start time
     */
    endTime?: number | null
    /**
     * Filter for days of week
     */
    daysOfWeek?: Array<number> | null
    /**
     * Filter for records that are in this list of operators
     */
    operators?: Array<string> | null
    /**
     * Filter for records that are in this list of payment types
     */
    paymentTypes?: Array<PaymentTypeEnum> | null
    /**
     * Filter for one or more shapes or districts
     */
    shapeUuids?: Array<string> | null
    /**
     * Selector for payments or sensor based occupancy
     */
    dataType?: ParkingOperatorDataType | null
    /**
     * Enforced hours or all hours for occupancy supply
     */
    hours?: OccupancyHoursEnum | null
  }): CancelablePromise<Array<ParkingSpatialResponse>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/regions/{region_id}/layers/{shape_layer_uuid}/curb_parking_insights/by_shape',
      path: {
        region_id: regionId,
        shape_layer_uuid: shapeLayerUuid,
      },
      query: {
        metric: metric,
        start_date: startDate,
        end_date: endDate,
        start_time: startTime,
        end_time: endTime,
        days_of_week: daysOfWeek,
        operators: operators,
        payment_types: paymentTypes,
        shape_uuids: shapeUuids,
        data_type: dataType,
        hours: hours,
      },
      errors: {
        422: `Validation Error`,
      },
    })
  }
  /**
   * Get Occupancy Available Hours
   * Occupancy hours modes with data for the layer. The FE grays out any mode not
   * returned and falls back to all_hours.
   * @returns OccupancyHoursEnum Successful Response
   * @throws ApiError
   */
  public getOccupancyAvailableHours({
    regionId,
    shapeLayerUuid,
    parkingSpaceCountProvider,
    dataType,
  }: {
    /**
     * Region identifier
     */
    regionId: string
    /**
     * Layer identifier
     */
    shapeLayerUuid: string
    /**
     * Override the parking space count provider
     */
    parkingSpaceCountProvider?: string | null
    /**
     * Data type whose schedule determines enforced availability
     */
    dataType?: ParkingOperatorDataType | null
  }): CancelablePromise<Array<OccupancyHoursEnum>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/regions/{region_id}/layers/{shape_layer_uuid}/curb_parking_insights/occupancy/available_hours',
      path: {
        region_id: regionId,
        shape_layer_uuid: shapeLayerUuid,
      },
      query: {
        parking_space_count_provider: parkingSpaceCountProvider,
        data_type: dataType,
      },
      errors: {
        422: `Validation Error`,
      },
    })
  }
  /**
   * Get Curb Parking Insights Occupancy Vector
   * Generates vector tiles for curb parking insights data, split by shape. Also
   * returns an int or float for the metric passed in as a filter.
   * @returns string Successful Response
   * @throws ApiError
   */
  public getCurbParkingInsightsOccupancyVector({
    regionId,
    shapeLayerUuid,
    z,
    x,
    y,
    startDate,
    endDate,
    parkingSpaceCountProvider,
    useDifference = false,
    startTime,
    endTime,
    daysOfWeek,
    operators,
    paymentTypes,
    shapeUuids,
    dataType,
    hours,
    ifModifiedSince,
  }: {
    /**
     * Region identifier
     */
    regionId: string
    /**
     * Layer identifier
     */
    shapeLayerUuid: string
    z: number
    x: number
    y: number
    /**
     * Filter for records that end after the provided ISO start date
     */
    startDate: string
    /**
     * Filter for records that start on or before the provided ISO end date
     */
    endDate: string
    /**
     * Override the parking space count provider
     */
    parkingSpaceCountProvider?: string | null
    /**
     * Calculate the difference between data types
     */
    useDifference?: boolean
    /**
     * Filter for records that end after the provided ISO start time
     */
    startTime?: number | null
    /**
     * Filter for records that start on or before the provided ISO start time
     */
    endTime?: number | null
    /**
     * Filter for days of week
     */
    daysOfWeek?: Array<number> | null
    /**
     * Filter for records that are in this list of operators
     */
    operators?: Array<string> | null
    /**
     * Filter for records that are in this list of payment types
     */
    paymentTypes?: Array<PaymentTypeEnum> | null
    /**
     * Filter for one or more shapes or districts
     */
    shapeUuids?: Array<string> | null
    /**
     * Selector for payments or sensor based occupancy
     */
    dataType?: ParkingOperatorDataType | null
    /**
     * Enforced hours or all hours for occupancy supply
     */
    hours?: OccupancyHoursEnum | null
    ifModifiedSince?: string | null
  }): CancelablePromise<string> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/regions/{region_id}/layers/{shape_layer_uuid}/curb_parking_insights/occupancy/vector/{z}/{x}/{y}',
      path: {
        region_id: regionId,
        shape_layer_uuid: shapeLayerUuid,
        z: z,
        x: x,
        y: y,
      },
      query: {
        parking_space_count_provider: parkingSpaceCountProvider,
        use_difference: useDifference,
        start_date: startDate,
        end_date: endDate,
        start_time: startTime,
        end_time: endTime,
        days_of_week: daysOfWeek,
        operators: operators,
        payment_types: paymentTypes,
        shape_uuids: shapeUuids,
        data_type: dataType,
        hours: hours,
        if_modified_since: ifModifiedSince,
      },
      errors: {
        422: `Validation Error`,
      },
    })
  }
  /**
   * Get Occupancy
   * Returns aggregated parking occupancy data, with an optional compare period.
   * @returns OccupancyWithCompareResponse Successful Response
   * @throws ApiError
   */
  public getOccupancy({
    regionId,
    shapeLayerUuid,
    startDate,
    endDate,
    startTime,
    endTime,
    parkingSpaceCountProvider,
    useDifference = false,
    aggregateBy,
    daysOfWeek,
    shapeUuids,
    dataType,
    hours,
    startDateCompare,
    endDateCompare,
  }: {
    /**
     * Region identifier
     */
    regionId: string
    /**
     * Layer identifier
     */
    shapeLayerUuid: string
    /**
     * Filter parking occupancy/turnover after the provided ISO start date
     */
    startDate: string
    /**
     * Filter parking occupancy/turnover that started before the provided ISO end date
     */
    endDate: string
    /**
     * Filter parking occupancy/turnover that end after the provided local ISO start time (24 hour format)
     */
    startTime: number
    /**
     * Filter parking occupancy/turnover that start on or before the provided local ISO start time (24 hour format)
     */
    endTime: number
    /**
     * Override the parking space count provider
     */
    parkingSpaceCountProvider?: string | null
    /**
     * Calculate the difference between data types
     */
    useDifference?: boolean
    /**
     * Group results by: day | week | month | year
     */
    aggregateBy?: TimePeriodEnum | null
    /**
     * Filter parking occupancy/turnover for those that apply weekly on ISO days of week
     */
    daysOfWeek?: Array<number> | null
    /**
     * Filter for one or more shapes or districts
     */
    shapeUuids?: Array<string> | null
    /**
     * Selector for payments or sensor based occupancy
     */
    dataType?: ParkingOperatorDataType | null
    /**
     * Enforced (meter-active) hours or all hours for occupancy supply
     */
    hours?: OccupancyHoursEnum | null
    /**
     * Compare period start date
     */
    startDateCompare?: string | null
    /**
     * Compare period end date
     */
    endDateCompare?: string | null
  }): CancelablePromise<OccupancyWithCompareResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/regions/{region_id}/layers/{shape_layer_uuid}/curb_parking_insights/occupancy',
      path: {
        region_id: regionId,
        shape_layer_uuid: shapeLayerUuid,
      },
      query: {
        parking_space_count_provider: parkingSpaceCountProvider,
        use_difference: useDifference,
        aggregate_by: aggregateBy,
        start_date: startDate,
        end_date: endDate,
        start_time: startTime,
        end_time: endTime,
        days_of_week: daysOfWeek,
        shape_uuids: shapeUuids,
        data_type: dataType,
        hours: hours,
        start_date_compare: startDateCompare,
        end_date_compare: endDateCompare,
      },
      errors: {
        422: `Validation Error`,
      },
    })
  }
  /**
   * Get Occupancy Legend Values
   * Returns the full array of values for a given metric (eg. total sessions),
   * for all parking meter events in a given time period in the parking districts
   * shape_layer, with all the revenue, paid time and session counts assigned
   * to the first hour in which the parking event occurs. Optional operator and
   * payment type filters on the data.
   * @returns number Successful Response
   * @throws ApiError
   */
  public getOccupancyLegendValues({
    regionId,
    shapeLayerUuid,
    metric,
    startDate,
    endDate,
    parkingSpaceCountProvider,
    useDifference = false,
    startTime,
    endTime,
    daysOfWeek,
    operators,
    paymentTypes,
    shapeUuids,
    dataType,
    hours,
  }: {
    /**
     * Region identifier
     */
    regionId: string
    /**
     * Layer identifier
     */
    shapeLayerUuid: string
    metric: OccupancyMetricsEnum
    /**
     * Filter for records that end after the provided ISO start date
     */
    startDate: string
    /**
     * Filter for records that start on or before the provided ISO end date
     */
    endDate: string
    /**
     * Override the parking space count provider
     */
    parkingSpaceCountProvider?: string | null
    /**
     * Calculate the difference between data types
     */
    useDifference?: boolean
    /**
     * Filter for records that end after the provided ISO start time
     */
    startTime?: number | null
    /**
     * Filter for records that start on or before the provided ISO start time
     */
    endTime?: number | null
    /**
     * Filter for days of week
     */
    daysOfWeek?: Array<number> | null
    /**
     * Filter for records that are in this list of operators
     */
    operators?: Array<string> | null
    /**
     * Filter for records that are in this list of payment types
     */
    paymentTypes?: Array<PaymentTypeEnum> | null
    /**
     * Filter for one or more shapes or districts
     */
    shapeUuids?: Array<string> | null
    /**
     * Selector for payments or sensor based occupancy
     */
    dataType?: ParkingOperatorDataType | null
    /**
     * Enforced hours or all hours for occupancy supply
     */
    hours?: OccupancyHoursEnum | null
  }): CancelablePromise<Array<number>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/regions/{region_id}/layers/{shape_layer_uuid}/curb_parking_insights/occupancy/legend_values',
      path: {
        region_id: regionId,
        shape_layer_uuid: shapeLayerUuid,
      },
      query: {
        metric: metric,
        parking_space_count_provider: parkingSpaceCountProvider,
        use_difference: useDifference,
        start_date: startDate,
        end_date: endDate,
        start_time: startTime,
        end_time: endTime,
        days_of_week: daysOfWeek,
        operators: operators,
        payment_types: paymentTypes,
        shape_uuids: shapeUuids,
        data_type: dataType,
        hours: hours,
      },
      errors: {
        422: `Validation Error`,
      },
    })
  }
  /**
   * Get Occupancy Data Types For Layer
   * Returns the available parking insights data types for a given layer.
   * @returns ParkingOperatorDataType Successful Response
   * @throws ApiError
   */
  public getOccupancyDataTypesForLayer({
    regionId,
    shapeLayerUuid,
  }: {
    /**
     * Region identifier
     */
    regionId: string
    /**
     * Layer identifier
     */
    shapeLayerUuid: string
  }): CancelablePromise<Array<ParkingOperatorDataType>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/regions/{region_id}/layers/{shape_layer_uuid}/curb_parking_insights/occupancy/data_types',
      path: {
        region_id: regionId,
        shape_layer_uuid: shapeLayerUuid,
      },
      errors: {
        422: `Validation Error`,
      },
    })
  }
  /**
   * Get Averaged Occupancy
   * Heatgrid: single occupancy metric averaged by ISO day-of-week x hour-of-day.
   * @returns AveragedParkingCountsResponse Successful Response
   * @throws ApiError
   */
  public getAveragedOccupancy({
    regionId,
    shapeLayerUuid,
    metric,
    startDate,
    endDate,
    startTime,
    endTime,
    parkingSpaceCountProvider,
    useDifference = false,
    daysOfWeek,
    shapeUuids,
    dataType,
    hours,
    startDateCompare,
    endDateCompare,
  }: {
    /**
     * Region identifier
     */
    regionId: string
    /**
     * Layer identifier
     */
    shapeLayerUuid: string
    /**
     * Occupancy metric to average
     */
    metric: OccupancyMetricsEnum
    /**
     * Filter parking occupancy/turnover after the provided ISO start date
     */
    startDate: string
    /**
     * Filter parking occupancy/turnover that started before the provided ISO end date
     */
    endDate: string
    /**
     * Filter parking occupancy/turnover that end after the provided local ISO start time (24 hour format)
     */
    startTime: number
    /**
     * Filter parking occupancy/turnover that start on or before the provided local ISO start time (24 hour format)
     */
    endTime: number
    /**
     * Override the parking space count provider
     */
    parkingSpaceCountProvider?: string | null
    /**
     * Calculate the difference between data types
     */
    useDifference?: boolean
    /**
     * Filter parking occupancy/turnover for those that apply weekly on ISO days of week
     */
    daysOfWeek?: Array<number> | null
    /**
     * Filter for one or more shapes or districts
     */
    shapeUuids?: Array<string> | null
    /**
     * Selector for payments or sensor based occupancy
     */
    dataType?: ParkingOperatorDataType | null
    /**
     * Enforced (meter-active) hours or all hours for occupancy supply
     */
    hours?: OccupancyHoursEnum | null
    /**
     * Compare period start date
     */
    startDateCompare?: string | null
    /**
     * Compare period end date
     */
    endDateCompare?: string | null
  }): CancelablePromise<Array<AveragedParkingCountsResponse>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/regions/{region_id}/layers/{shape_layer_uuid}/curb_parking_insights/averaged_occupancy',
      path: {
        region_id: regionId,
        shape_layer_uuid: shapeLayerUuid,
      },
      query: {
        metric: metric,
        parking_space_count_provider: parkingSpaceCountProvider,
        use_difference: useDifference,
        start_date: startDate,
        end_date: endDate,
        start_time: startTime,
        end_time: endTime,
        days_of_week: daysOfWeek,
        shape_uuids: shapeUuids,
        data_type: dataType,
        hours: hours,
        start_date_compare: startDateCompare,
        end_date_compare: endDateCompare,
      },
      errors: {
        422: `Validation Error`,
      },
    })
  }
  /**
   * Get Parking Sessions
   * Returns disaggregated session data from requested dates, vendor,
   * payment type, and source feed. Data is read from processed parking insights
   * parquet files in Google Storage.
   * @returns Page_ParkingTransactionResponse_ Return a CSV report for download or optionally in json format
   * @throws ApiError
   */
  public getParkingSessions({
    regionId,
    shapeLayerUuid,
    startDate,
    endDate,
    page = 1,
    size = 50,
    paymentTypes,
    sessionIds,
    locationIds,
    vendors,
    shapeUuids,
    startTimeGte,
    startTimeLt,
    endTimeGte,
    endTimeLt,
    daysOfWeek,
    durationGte,
    durationLte,
    revenueGte,
    revenueLte,
    accept = 'application/json',
  }: {
    /**
     * Region identifier
     */
    regionId: string
    /**
     * Layer identifier
     */
    shapeLayerUuid: string
    /**
     * Start date filter
     */
    startDate: string
    /**
     * End date filter
     */
    endDate: string
    page?: number
    size?: number
    /**
     * Payment type filters
     */
    paymentTypes?: Array<PaymentTypeEnum> | null
    /**
     * List of session ids to filter with
     */
    sessionIds?: Array<string> | null
    /**
     * List of location ids to filter with
     */
    locationIds?: Array<string> | null
    /**
     * Vendor filter
     */
    vendors?: Array<string> | null
    /**
     * Shapes filter. The sentinel `(blank)` means the opposite: return only sessions whose location has no shape in this layer. It must be sent on its own; passing it alongside real shape uuids is an error.
     */
    shapeUuids?: Array<string> | null
    /**
     * Start time filter range lower bound value, inclusive
     */
    startTimeGte?: number | null
    /**
     * Start time filter range upper bound value
     */
    startTimeLt?: number | null
    /**
     * End time filter range lower bound value, inclusive
     */
    endTimeGte?: number | null
    /**
     * End time filter range upper bound value
     */
    endTimeLt?: number | null
    /**
     * Days of week filter
     */
    daysOfWeek?: Array<number> | null
    /**
     * Duration filter range lower bound value, inclusive, in seconds
     */
    durationGte?: number | null
    /**
     * Duration filter range upper bound value, inclusive, in seconds
     */
    durationLte?: number | null
    /**
     * Revenue filter range lower bound value, inclusive, in cents
     */
    revenueGte?: number | null
    /**
     * Revenue filter range upper bound value, inclusive, in cents
     */
    revenueLte?: number | null
    accept?: string
  }): CancelablePromise<Page_ParkingTransactionResponse_> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/regions/{region_id}/layers/{shape_layer_uuid}/curb_parking_insights/sessions',
      path: {
        region_id: regionId,
        shape_layer_uuid: shapeLayerUuid,
      },
      headers: {
        accept: accept,
      },
      query: {
        page: page,
        size: size,
        start_date: startDate,
        end_date: endDate,
        payment_types: paymentTypes,
        session_ids: sessionIds,
        location_ids: locationIds,
        vendors: vendors,
        shape_uuids: shapeUuids,
        start_time_gte: startTimeGte,
        start_time_lt: startTimeLt,
        end_time_gte: endTimeGte,
        end_time_lt: endTimeLt,
        days_of_week: daysOfWeek,
        duration_gte: durationGte,
        duration_lte: durationLte,
        revenue_gte: revenueGte,
        revenue_lte: revenueLte,
      },
      errors: {
        422: `Validation Error`,
      },
    })
  }
  /**
   * Get Parking Sessions Shape Lookup
   * Get lookup for sessions zone IDs to shapes
   * for a given region, operator, and source feed.
   * @returns string Successful Response
   * @throws ApiError
   */
  public getParkingSessionsShapeLookup({
    regionId,
    shapeLayerUuid,
  }: {
    /**
     * Region identifier
     */
    regionId: string
    /**
     * Layer identifier
     */
    shapeLayerUuid: string
  }): CancelablePromise<Record<string, string>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/regions/{region_id}/layers/{shape_layer_uuid}/curb_parking_insights/sessions/shape_lookup',
      path: {
        region_id: regionId,
        shape_layer_uuid: shapeLayerUuid,
      },
      errors: {
        422: `Validation Error`,
      },
    })
  }
  /**
   * Get Parking Sessions Statistics
   * Returns the sum total revenue, session count, total paid duration,
   * average revenue per session, and average paid time per session
   * for a filtered set of individual parking sessions.
   * @returns ParkingStatisticsResponse Successful Response
   * @throws ApiError
   */
  public getParkingSessionsStatistics({
    regionId,
    shapeLayerUuid,
    startDate,
    endDate,
    paymentTypes,
    sessionIds,
    locationIds,
    vendors,
    shapeUuids,
    startTimeGte,
    startTimeLt,
    endTimeGte,
    endTimeLt,
    daysOfWeek,
    durationGte,
    durationLte,
    revenueGte,
    revenueLte,
  }: {
    /**
     * Region identifier
     */
    regionId: string
    /**
     * Layer identifier
     */
    shapeLayerUuid: string
    /**
     * Start date filter
     */
    startDate: string
    /**
     * End date filter
     */
    endDate: string
    /**
     * Payment type filters
     */
    paymentTypes?: Array<PaymentTypeEnum> | null
    /**
     * List of session ids to filter with
     */
    sessionIds?: Array<string> | null
    /**
     * List of location ids to filter with
     */
    locationIds?: Array<string> | null
    /**
     * Vendor filter
     */
    vendors?: Array<string> | null
    /**
     * Shapes filter. The sentinel `(blank)` means the opposite: return only sessions whose location has no shape in this layer. It must be sent on its own; passing it alongside real shape uuids is an error.
     */
    shapeUuids?: Array<string> | null
    /**
     * Start time filter range lower bound value, inclusive
     */
    startTimeGte?: number | null
    /**
     * Start time filter range upper bound value
     */
    startTimeLt?: number | null
    /**
     * End time filter range lower bound value, inclusive
     */
    endTimeGte?: number | null
    /**
     * End time filter range upper bound value
     */
    endTimeLt?: number | null
    /**
     * Days of week filter
     */
    daysOfWeek?: Array<number> | null
    /**
     * Duration filter range lower bound value, inclusive, in seconds
     */
    durationGte?: number | null
    /**
     * Duration filter range upper bound value, inclusive, in seconds
     */
    durationLte?: number | null
    /**
     * Revenue filter range lower bound value, inclusive, in cents
     */
    revenueGte?: number | null
    /**
     * Revenue filter range upper bound value, inclusive, in cents
     */
    revenueLte?: number | null
  }): CancelablePromise<ParkingStatisticsResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/regions/{region_id}/layers/{shape_layer_uuid}/curb_parking_insights/sessions/statistics',
      path: {
        region_id: regionId,
        shape_layer_uuid: shapeLayerUuid,
      },
      query: {
        start_date: startDate,
        end_date: endDate,
        payment_types: paymentTypes,
        session_ids: sessionIds,
        location_ids: locationIds,
        vendors: vendors,
        shape_uuids: shapeUuids,
        start_time_gte: startTimeGte,
        start_time_lt: startTimeLt,
        end_time_gte: endTimeGte,
        end_time_lt: endTimeLt,
        days_of_week: daysOfWeek,
        duration_gte: durationGte,
        duration_lte: durationLte,
        revenue_gte: revenueGte,
        revenue_lte: revenueLte,
      },
      errors: {
        422: `Validation Error`,
      },
    })
  }
  /**
   * Get Aggregated Parking Counts
   * @returns ParkingCountResponse Successful Response
   * @throws ApiError
   */
  public getAggregatedParkingCounts({
    regionId,
    shapeLayerUuid,
    startDate,
    endDate,
    metric,
    startTime,
    endTime,
    daysOfWeek,
    timePeriodType,
    operators,
    paymentTypes,
    aggregation,
    shapeUuids,
  }: {
    /**
     * Region identifier
     */
    regionId: string
    /**
     * Layer identifier
     */
    shapeLayerUuid: string
    /**
     * Filter for records that end after the provided ISO start date
     */
    startDate: string
    /**
     * Filter for records that start on or before the provided ISO end date
     */
    endDate: string
    /**
     * Return counts for revenue, sessions, average paid time, or average paid revenue.
     */
    metric: ParkingInsightsMetricsEnum
    /**
     * Filter for records that end after the provided ISO start time
     */
    startTime?: number | null
    /**
     * Filter for records that start on or before the provided ISO start time
     */
    endTime?: number | null
    /**
     * Filter for days of week
     */
    daysOfWeek?: Array<number> | null
    /**
     * Group and aggregate results by the given time period
     */
    timePeriodType?: TimePeriodEnum | null
    /**
     * Filter for records that are in this list of operators
     */
    operators?: Array<string> | null
    /**
     * Filter for records that are in this list of payment types
     */
    paymentTypes?: Array<PaymentTypeEnum> | null
    /**
     * Aggregate results by either operator or payment type
     */
    aggregation?: AggregateByEnum | null
    /**
     * Filter for records that are in this list of parking districts
     */
    shapeUuids?: Array<string> | null
  }): CancelablePromise<Array<ParkingCountResponse>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/regions/{region_id}/layers/{shape_layer_uuid}/curb_parking_insights/aggregated_counts',
      path: {
        region_id: regionId,
        shape_layer_uuid: shapeLayerUuid,
      },
      query: {
        start_date: startDate,
        end_date: endDate,
        metric: metric,
        start_time: startTime,
        end_time: endTime,
        days_of_week: daysOfWeek,
        time_period_type: timePeriodType,
        operators: operators,
        payment_types: paymentTypes,
        aggregation: aggregation,
        shape_uuids: shapeUuids,
      },
      errors: {
        422: `Validation Error`,
      },
    })
  }
  /**
   * Get Averaged Parking Counts By Day Of Week
   * @returns AveragedParkingCountsResponse Successful Response
   * @throws ApiError
   */
  public getAveragedParkingCountsByDayOfWeek({
    regionId,
    shapeLayerUuid,
    startDate,
    endDate,
    metric,
    startTime,
    endTime,
    daysOfWeek,
    timePeriodType,
    operators,
    paymentTypes,
    aggregation,
    shapeUuids,
  }: {
    /**
     * Region identifier
     */
    regionId: string
    /**
     * Layer identifier
     */
    shapeLayerUuid: string
    /**
     * Filter for records that end after the provided ISO start date
     */
    startDate: string
    /**
     * Filter for records that start on or before the provided ISO end date
     */
    endDate: string
    /**
     * Return counts for revenue, sessions, average paid time, or average paid revenue.
     */
    metric: ParkingInsightsMetricsEnum
    /**
     * Filter for records that end after the provided ISO start time
     */
    startTime?: number | null
    /**
     * Filter for records that start on or before the provided ISO start time
     */
    endTime?: number | null
    /**
     * Filter for days of week
     */
    daysOfWeek?: Array<number> | null
    /**
     * Group and aggregate results by the given time period
     */
    timePeriodType?: TimePeriodEnum | null
    /**
     * Filter for records that are in this list of operators
     */
    operators?: Array<string> | null
    /**
     * Filter for records that are in this list of payment types
     */
    paymentTypes?: Array<PaymentTypeEnum> | null
    /**
     * Aggregate results by either operator or payment type
     */
    aggregation?: AggregateByEnum | null
    /**
     * Filter for records that are in this list of parking districts
     */
    shapeUuids?: Array<string> | null
  }): CancelablePromise<Array<AveragedParkingCountsResponse>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/regions/{region_id}/layers/{shape_layer_uuid}/curb_parking_insights/averaged_counts',
      path: {
        region_id: regionId,
        shape_layer_uuid: shapeLayerUuid,
      },
      query: {
        start_date: startDate,
        end_date: endDate,
        metric: metric,
        start_time: startTime,
        end_time: endTime,
        days_of_week: daysOfWeek,
        time_period_type: timePeriodType,
        operators: operators,
        payment_types: paymentTypes,
        aggregation: aggregation,
        shape_uuids: shapeUuids,
      },
      errors: {
        422: `Validation Error`,
      },
    })
  }
  /**
   * Get Occupancy Top Bottom By Shape Endpoint
   * Top and bottom N shapes ranked by the selected occupancy metric (payments).
   * One DB scan, sorted once, sliced from both ends. Sensor values are included
   * and are NULL when no sensor data exists.
   * @returns OccupancyTopBottomByShapeResponse Successful Response
   * @throws ApiError
   */
  public getOccupancyTopBottomByShapeEndpoint({
    regionId,
    shapeLayerUuid,
    startDate,
    endDate,
    startTime,
    endTime,
    metric,
    limit = 3,
    aggregateBy,
    daysOfWeek,
    shapeUuids,
    dataType,
    hours,
    startDateCompare,
    endDateCompare,
  }: {
    /**
     * Region identifier
     */
    regionId: string
    /**
     * Layer identifier
     */
    shapeLayerUuid: string
    /**
     * Filter parking occupancy/turnover after the provided ISO start date
     */
    startDate: string
    /**
     * Filter parking occupancy/turnover that started before the provided ISO end date
     */
    endDate: string
    /**
     * Filter parking occupancy/turnover that end after the provided local ISO start time (24 hour format)
     */
    startTime: number
    /**
     * Filter parking occupancy/turnover that start on or before the provided local ISO start time (24 hour format)
     */
    endTime: number
    /**
     * Occupancy metric used for ranking
     */
    metric?: OccupancyMetricsEnum | null
    limit?: number
    /**
     * Group results by: day | week | month | year
     */
    aggregateBy?: TimePeriodEnum | null
    /**
     * Filter parking occupancy/turnover for those that apply weekly on ISO days of week
     */
    daysOfWeek?: Array<number> | null
    /**
     * Filter for one or more shapes or districts
     */
    shapeUuids?: Array<string> | null
    /**
     * Selector for payments or sensor based occupancy
     */
    dataType?: ParkingOperatorDataType | null
    /**
     * Enforced (meter-active) hours or all hours for occupancy supply
     */
    hours?: OccupancyHoursEnum | null
    /**
     * Compare period start date
     */
    startDateCompare?: string | null
    /**
     * Compare period end date
     */
    endDateCompare?: string | null
  }): CancelablePromise<OccupancyTopBottomByShapeResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/regions/{region_id}/layers/{shape_layer_uuid}/curb_parking_insights/occupancy/top_bottom_by_shape',
      path: {
        region_id: regionId,
        shape_layer_uuid: shapeLayerUuid,
      },
      query: {
        metric: metric,
        limit: limit,
        aggregate_by: aggregateBy,
        start_date: startDate,
        end_date: endDate,
        start_time: startTime,
        end_time: endTime,
        days_of_week: daysOfWeek,
        shape_uuids: shapeUuids,
        data_type: dataType,
        hours: hours,
        start_date_compare: startDateCompare,
        end_date_compare: endDateCompare,
      },
      errors: {
        422: `Validation Error`,
      },
    })
  }
  /**
   * Get Parking Date Range
   * Get min and max dates for parking data for a region
   * @returns ParkingDateRangeResponse Successful Response
   * @throws ApiError
   */
  public getParkingDateRange({
    regionId,
  }: {
    /**
     * Region identifier
     */
    regionId: string
  }): CancelablePromise<ParkingDateRangeResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/regions/{region_id}/curb_parking_insights/date_range',
      path: {
        region_id: regionId,
      },
      errors: {
        422: `Validation Error`,
      },
    })
  }
  /**
   * Get Parking Download Urls
   * @returns ParkingDownloadUrlsResponse Successful Response
   * @throws ApiError
   */
  public getParkingDownloadUrls({
    regionId,
    startDate,
    endDate,
    vendors,
  }: {
    /**
     * Region identifier
     */
    regionId: string
    /**
     * Start date filter
     */
    startDate: string
    /**
     * End date filter
     */
    endDate: string
    /**
     * Vendor filter
     */
    vendors?: Array<string> | null
  }): CancelablePromise<Array<ParkingDownloadUrlsResponse>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/regions/{region_id}/curb_parking_insights/download_urls',
      path: {
        region_id: regionId,
      },
      query: {
        start_date: startDate,
        end_date: endDate,
        vendors: vendors,
      },
      errors: {
        422: `Validation Error`,
      },
    })
  }
  /**
   * Get Occupancy Data Types
   * Returns the available parking insights data types for the region.
   * @returns ParkingOperatorDataType Successful Response
   * @throws ApiError
   */
  public getOccupancyDataTypes({
    regionId,
  }: {
    /**
     * Region identifier
     */
    regionId: string
  }): CancelablePromise<Array<ParkingOperatorDataType>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/regions/{region_id}/curb_parking_insights/occupancy/data_types',
      path: {
        region_id: regionId,
      },
      errors: {
        422: `Validation Error`,
      },
    })
  }
  /**
   * Get Parking Sessions Date Range
   * Get min and max dates for parking session data for a region
   * @returns ParkingDateRangeResponse Successful Response
   * @throws ApiError
   */
  public getParkingSessionsDateRange({
    regionId,
  }: {
    /**
     * Region identifier
     */
    regionId: string
  }): CancelablePromise<ParkingDateRangeResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/regions/{region_id}/curb_parking_insights/sessions/date_range',
      path: {
        region_id: regionId,
      },
      errors: {
        422: `Validation Error`,
      },
    })
  }
  /**
   * Get Curb Parking Insights Operators
   * Returns a list of parking insights operators for a given region.
   * @returns Page_ParkingOperators_ Successful Response
   * @throws ApiError
   */
  public getCurbParkingInsightsOperators({
    regionId,
    page = 1,
    size = 50,
    dataType,
    isCds,
    requestBody,
  }: {
    /**
     * Region identifier
     */
    regionId: string
    page?: number
    size?: number
    dataType?: string | null
    isCds?: boolean | null
    requestBody?: Array<string>
  }): CancelablePromise<Page_ParkingOperators_> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/regions/{region_id}/curb_parking_insights/operators',
      path: {
        region_id: regionId,
      },
      query: {
        page: page,
        size: size,
        data_type: dataType,
        is_cds: isCds,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    })
  }
  /**
   * Get Parking Location Layers
   * @returns Page_LayerResponse_ Successful Response
   * @throws ApiError
   */
  public getParkingLocationLayers({
    regionId,
    page = 1,
    size = 50,
  }: {
    /**
     * Region identifier
     */
    regionId: string
    page?: number
    size?: number
  }): CancelablePromise<Page_LayerResponse_> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/regions/{region_id}/curb_parking_insights/location_layers',
      path: {
        region_id: regionId,
      },
      query: {
        page: page,
        size: size,
      },
      errors: {
        422: `Validation Error`,
      },
    })
  }
}
